export default __webpack_public_path__ + "static/media/closed_eye.4440c3f0.svg";